const NavLinks = [
  {
    id: 1,
    link: 'home',
  },
  {
    id: 2,
    link: 'experience',
  },
  {
    id: 3,
    link: 'portfolio',
  },
  {
    id: 4,
    link: 'skills',
  },
  {
    id: 5,
    link: 'certifications',
  },
  {
    id: 6,
    link: 'contact',
  },
];

export default NavLinks;
